import { capabilities } from 'navigation-components/capabilities';
import { useCapability } from 'navigation-components/platform/hooks';
import { useCallback, useEffect } from 'react';
import { globalStylesActions } from '../../reducers/GlobalStyles';
import { useAppDispatch } from '../index';
import { StylesStorage } from './styles-storage';
export const useGlobalStyles = () => {
  const dispatch = useAppDispatch();
  const {
    subscribe: onUpsert
  } = useCapability(capabilities.UPSERT_GLOBAL_STYLES_CAP.getName());
  const {
    subscribe: onDelete
  } = useCapability(capabilities.DELETE_GLOBAL_STYLES_CAP.getName());
  const handleUpsertStylesheet = useCallback((args, {
    source
  }) => {
    const stylesheet = Object.assign({
      source
    }, args);
    dispatch(globalStylesActions.upsertStylesheet(stylesheet));
    if (args.persist) {
      const {
        mode,
        id
      } = args.persist;
      const stylesStorage = StylesStorage.getInstance(mode);
      stylesStorage.persist(id, stylesheet);
    }
  }, [dispatch]);
  const handleDeleteStylesheet = useCallback(args => {
    dispatch(globalStylesActions.deleteStylesheet(args));
    if (args.by === 'persistenceId') {
      const {
        mode,
        value: id
      } = args;
      const stylesStorage = StylesStorage.getInstance(mode);
      stylesStorage.remove(id);
    }
  }, [dispatch]);
  useEffect(() => {
    const unsubscribeUpserts = onUpsert(handleUpsertStylesheet);
    const unsubscribeDeletes = onDelete(handleDeleteStylesheet);
    return () => {
      unsubscribeUpserts();
      unsubscribeDeletes();
    };
  }, [handleDeleteStylesheet, handleUpsertStylesheet, onDelete, onUpsert]);
};